// LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import { setToken } from '../utils/auth';

function LoginPage({ onLoginSuccess }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const clearAllCache = () => {
        sessionStorage.removeItem('cachedPackages');
        sessionStorage.removeItem('cacheTimestamp');
        sessionStorage.removeItem('lectorName');
        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith('packageDetail_') || key.startsWith('lessons_')) {
                sessionStorage.removeItem(key);
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Login attempt started');
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await login(email, password);
            console.log('Login response received:', response);

            if (response.access_token) {
                setToken(response.access_token);
                console.log('Token set in localStorage');

                // VYMAZAŤ STARÝ CACHE PRED ULOŽENÍM NOVÝCH ÚDAJOV
                clearAllCache();

                // Uložiť meno lektora do sessionStorage
                if (response.lector_name) {
                    sessionStorage.setItem('lectorName', response.lector_name);
                    console.log('Lector name saved to sessionStorage:', response.lector_name);
                }

                // Uložiť email lektora do sessionStorage
                sessionStorage.setItem('lectorEmail', email);  // PRIDANÉ
                console.log('Lector email saved to sessionStorage:', email);


                setSuccess('Úspešne prihlásené! Presmerovávam...');
                console.log('Login successful, calling onLoginSuccess');

                // Informovať App komponent o úspešnom prihlásení
                if (onLoginSuccess) {
                    onLoginSuccess();
                }

                // Presmerovať na dashboard
                setTimeout(() => {
                    console.log('Navigating to dashboard');
                    navigate('/dashboard', { replace: true });
                }, 500);
            } else {
                throw new Error('No access token received');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.message || 'Prihlasovanie zlyhalo. Skontrolujte údaje.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-form">
                <h2 className="login-title">Prihlásenie lektora</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Email:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={loading}
                            placeholder="vas@email.com"
                        />
                    </div>
                    <div className="form-group">
                        <label>Heslo:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={loading}
                            placeholder="Vaše heslo"
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}
                    {success && <div className="success-message">{success}</div>}

                    <button
                        type="submit"
                        disabled={loading}
                        className="login-button"
                    >
                        {loading ? 'Prihlasujem...' : 'Prihlásiť sa'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default LoginPage;